import { compareStudentNames } from "../../core/utils/studentName";
import React, { useEffect, useState } from "react";
import StudentCard from "./StudentCard";
import UploadPhotoModal from "./UploadPhotoModal";
import "./trombinoscope.css";
import { getAllClass } from "../../api/pedagogicElement";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { Select } from "antd";
import { getAllStudentByYear } from "../../api/etudiants";
import { deleteAvatar, getAvatarFileById } from "../../api/avatar";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { my_routes } from "../router/all_routes";
import BulkPhotoImportModal from "./BulkPhotoImportModal";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";

// bouton pour réinitialiser un mot de passe
const ProtectedBtnBulkImportPhoto = withPermission(
  (props: any) => (
    <li>
      <button
        // disabled={!props.record.email}
        onClick={() => props.setShowImportTof(true)}
        className="btn btn-dark rounded-1"
      >
        <i className="ti ti-photo me-2" />
        Import en masse Avatar
      </button>
    </li>
  ),
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);

const Trombinoscope: React.FC = () => {
  const routes = my_routes;

  const { selectedYear } = useAcademicYear();

  const [classes, setClasses] = useState<any[]>([]);
  const [etudiants, setEtudiants] = useState<any[]>([]);
  const [filteredEtudiants, setFilteredEtudiants] = useState<any[]>([]);
  const [selectedClasse, setSelectedClasse] = useState<any>();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadEtudiant, setUploadEtudiant] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [showImportTof, setShowImportTof] = useState<boolean>(false);

  const loadClasses = async () => {
    try {
      const resp = await getAllClass(selectedYear?.id);
      // console.log("All Class: ", resp.data);

      const classesData =
        resp.data
          .slice() // pour éviter de modifier directement la réponse
          .sort((a: any, b: any) => {
            // Tri par Level.label
            const levelCompare = a.Level.label.localeCompare(
              b.Level.label,
              "fr",
              { numeric: true },
            );
            if (levelCompare !== 0) return levelCompare;

            // Si même Level, tri par class label
            return a.label.localeCompare(b.label, "fr", { numeric: true });
          }) ?? [];

      setClasses(classesData);
    } catch (error: any) {
      // console.log("Erreur lors du chargement des classes: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const loadEtudiants = async () => {
    setLoading(true);
    try {
      const resp = await getAllStudentByYear(selectedYear?.id);
      // console.log("All Students:", resp.data);

      const formattedData = await Promise.all(
        resp.data.map(async (sdt: any) => {
          // console.log("STUDENPROFILE: ", sdt?.id);

          const avatar = await getAvatarFileById("StudentProfil", sdt?.id);
          // console.log("AVART RECEIVED: ", avatar);

          return { ...sdt, avatar: { ...avatar.data } };
        }),
      );

      // console.log("ENRICHED STUDENT: ", formattedData);
      setEtudiants(formattedData);
    } catch (error: any) {
      // console.log("Erreur lors du chargement des étudiants: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setLoading(false);
    }
  };

  // Load classes and student
  useEffect(() => {
    if (!selectedYear) return;
    loadClasses();
    loadEtudiants();
  }, [selectedYear]);

  // Apply filters
  useEffect(() => {
    let filtered = etudiants;

    if (selectedClasse) {
      filtered = filtered.filter(
        (e) => e?.Registrations[0]?.Class?.id === selectedClasse?.id,
      );
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (e) =>
          `${e?.lastname} ${e?.firstname}`.toLowerCase()?.includes(term) ||
          e?.email?.toLowerCase()?.includes(term),
      );
    }

    setFilteredEtudiants([...filtered].sort(compareStudentNames));
  }, [selectedClasse, searchTerm, etudiants]);

  const handleDeletePhoto = async (etudiant: any) => {
    try {
      await deleteAvatar(etudiant?.avatar?.id);
      // await etudiantsService.deletePhoto(etudiantId);
      setEtudiants(
        etudiants.map((e) =>
          e.id === etudiant?.id
            ? { ...e, avatar: { ...e.avatar, temporaryUrl: null } }
            : e,
        ),
      );
      toast.success("Photo supprimee avec succes");
    } catch (error: any) {
      // console.log("Erreur lors de la suppression: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const handleAddPhoto = (e: React.MouseEvent, etudiant: any) => {
    e.stopPropagation();
    setUploadEtudiant(etudiant);
    setShowUploadModal(true);
  };

  const handleUploadSuccess = () => {
    const loadEtudiants = async () => {
      try {
        const resp = await getAllStudentByYear(selectedYear?.id);
        // console.log("All Students:", resp.data);

        const formattedData = await Promise.all(
          resp.data.map(async (sdt: any) => {
            // console.log("STUDENPROFILE: ", sdt?.id);
            const avatar = await getAvatarFileById("StudentProfil", sdt?.id);
            // console.log("AVART RECEIVED: ", avatar);
            return { ...sdt, avatar: { ...avatar.data } };
          }),
        );

        // console.log("ENRICHED STUDENT: ",formattedData)
        setEtudiants(formattedData);
      } catch (error: any) {
        // console.log("Erreur lors du rechargement: ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );
      }
    };
    loadEtudiants();
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Trombinoscope</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Accueil</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Trombinoscope
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}
          <div className="trombinoscope-container">
            <div className="container-fluid">
              <div className="filters-section">
                <div className="filter-group">
                  <div className="filter-item">
                    <label htmlFor="classe-select">Classe</label>
                    <Select
                      showSearch
                      allowClear={true}
                      optionFilterProp="label"
                      dropdownMatchSelectWidth={false}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toString()
                          .toLowerCase()
                          .includes(input.toString().toLowerCase())
                      }
                      value={selectedClasse?.id}
                      onChange={(value) => {
                        const selected = classes.find(
                          (opt) => opt.id === value,
                        );
                        setSelectedClasse(selected);
                      }}
                      style={{
                        border: "none",
                        height: "40px",
                        // maxWidth: "150px",
                        width: "100%",
                      }}
                      placeholder="Toutes les classes"
                      options={classes.map((classe) => ({
                        label: `${classe?.Level?.label} - ${classe?.label}`,
                        value: classe?.id,
                      }))}
                    />
                  </div>

                  <div className="filter-item">
                    <label htmlFor="search-input">Rechercher</label>
                    <input
                      id="search-input"
                      type="text"
                      className="form-control"
                      placeholder="Nom, prénom ou email..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <ProtectedBtnBulkImportPhoto
                    setShowImportTof={setShowImportTof}
                  />
                </div>
              </div>

              {loading ? (
                <div className="etudiants-grid">
                  {Array.from({ length: 8 }).map((_, i) => (
                    <div key={i} className="skeleton-card">
                      <div className="skeleton-photo" />
                      <div className="p-3">
                        <div
                          className="skeleton-text"
                          style={{ width: "80%" }}
                        />
                        <div
                          className="skeleton-text mt-2"
                          style={{ width: "60%" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : filteredEtudiants.length === 0 ? (
                <div className="etudiants-grid">
                  <div className="empty-state">
                    <div className="empty-state-icon">🔍</div>
                    <h3>Aucun étudiant trouvé</h3>
                    <p>
                      {searchTerm || selectedClasse
                        ? "Essayez de modifier vos critères de recherche"
                        : "Aucun étudiant disponible pour le moment"}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="etudiants-grid">
                  {filteredEtudiants.map((etudiant) => (
                    <StudentCard
                      key={etudiant.id}
                      etudiant={etudiant}
                      onDeletePhoto={(e) => handleDeletePhoto(etudiant)}
                      onAddPhoto={(e) => handleAddPhoto(e, etudiant)}
                    />
                  ))}
                </div>
              )}
            </div>

            <UploadPhotoModal
              profilId={uploadEtudiant?.id}
              profilType="StudentProfil"
              isOpen={showUploadModal}
              onClose={() => setShowUploadModal(false)}
              onSuccess={handleUploadSuccess}
            />
          </div>
        </div>
      </div>
      <BulkPhotoImportModal
        show={showImportTof}
        onHide={() => setShowImportTof(false)}
        classes={classes.map((c) => {
          return {
            id: c.id,
            nom: c.label,
          };
        })}
      />
    </>
  );
};

export default Trombinoscope;
